module.exports = __webpack_public_path__ + "bd813748805862aee10e3966973f015e.pdf";